<template>
	<div>
		<p class="intro type--serif">We were unable to find any aircraft for this journey.</p>
		<div class="links type--s type--b type--sans">
			<a class="link" href="tel:02039207437">020 3920 7437</a>
			<a class="link" href="email:hello@flythq.com">hello@flythq.com</a>
		</div>
	</div>
</template>

<script>
export default {
	name: "AircraftNotFound"
}
</script>

<style lang="scss" scoped>
.intro {
	margin-bottom: 1rem;
}

.links > * {
	display: block;
}
</style>
